namespace Serenity {
    export interface OperationServiceResponse extends Serenity.ServiceResponse {
        ElapsedSeconds?: number;
    }
}
